import DialogWrapper2 from '../dialog/dialog_wrapper_v2';
import { i18n } from '../../i18n/i18n';
import React from 'react';
import ReactPlayer from 'react-player';
import { SectionStyle } from '../../helpers/SectionStyle';
import style from './buttons.less';

interface WVideoIconProps extends React.ClassAttributes<any> {
    title: string;
    videoUrl: string;
    color?: string;
    isSelection?: boolean;
    styleDivProps?: React.CSSProperties;
    styleProps?: React.CSSProperties;
}

interface WVideoIconState extends React.ClassAttributes<any> {
    showVideo: boolean;
}

export class WVideoIcon extends React.Component<WVideoIconProps, WVideoIconState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showVideo: false,
        };
    }

    render(): JSX.Element {
        const id: string = this.props.isSelection ? 'datenauswertung' : SectionStyle.getCurrentId();
        const elements: HTMLCollection = document.getElementsByTagName('body');
        const styleBody: CSSStyleDeclaration = elements.length ? window.getComputedStyle(elements[0]) : null;
        const color: string = this.props.color
            ? this.props.color
            : (styleBody ? styleBody.getPropertyValue((`--color-main-section-${id}`).toString()) : '#000');

        return (
            <div style={{ cursor: 'pointer', ...(this.props.styleDivProps || {}) }}
                onClick={(event: any) => { event.stopPropagation(); }}
                onMouseUp={() => this.setState({ showVideo: true })}
            >
                <button
                    className={style.videoButtonThemeSmall}
                    style={{ verticalAlign: 'center', backgroundColor: color, ...(this.props.styleProps || {}) }}
                    onClick={(event: any) => event.stopPropagation()}
                    onMouseUp={() => this.setState({ showVideo: true })}
                />
                <span
                    style={{
                        fontSize: 11, fontWeight: 'normal', fontStyle: 'normal', color, textDecoration: 'underline', top: -4,
                        marginLeft: 1, position: 'relative'
                    }}
                >
                    {i18n('Erklärvideo verfügbar')}
                </span>
                {this.state.showVideo && this.renderVideo()}
            </div>
        );
    }

    renderVideo(): JSX.Element {
        console.log('showVideo:', this.props.videoUrl);
        return (
            <DialogWrapper2
                styleClassExternal='player'
                title={this.props.title}
                width={880}
                verticalAlignCenter
                onAfterClose={() => this.setState({ showVideo: false })}
            >
                <ReactPlayer
                    url={this.props.videoUrl}
                    playing
                    controls
                    width='100%'
                    height='100%'
                />
            </DialogWrapper2>
        );
    }
}
